import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  serverUrl = environment.serverUrl;

  constructor(private http: HttpClient) { }

  login(data: any) {
    return this.http.post(`${this.serverUrl}/user/signin`, data);
  }

  forgotPassword(userData: any) {
    return this.http.post(`${this.serverUrl}/user/resetpassword/${userData}`, {});
  }

  resetPassword(token: any, data:any) {
    return this.http.post(`${this.serverUrl}/user/resetpassword/validate/${token}`, data);
  }

  setPassword(token : any, data : any){
    return this.http.put(`${this.serverUrl}/user/resetpassword/${token}`, data);
  }

}
